export default __webpack_public_path__ + "static/metatron-cfd7c286927ec27b37c3b6ec2179df36.svg";